import React from "react";
import Navbar from "../../../../components/navbar";
const Hero = () => {
  return (
    <div class="relative h-[95vh] flex items-center justify-center text-center bg-black">
      <Navbar />
      <video
        autoPlay={true}
        muted
        loop
        class="absolute top-0 left-0 w-full h-full object-cover z-0"
      >
        <source src="/herobg_video2.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* <!-- Dark Overlay --> */}
      <div class="absolute top-0 left-0 w-full h-full bg-black bg-opacity-55 z-10"></div>

      {/* <!-- Content --> */}
      <div class="relative z-20 md:mt-32 px-4 sm:px-6 lg:px-8">
        <h1 class="text-4xl md:text-6xl font-bold text-gray-200">
          Your Educational Journey Starts Here
        </h1>
        <p class="mt-4 text-lg md:text-xl text-gray-300">
          Expert Guidance, Trusted Partnerships, and Endless Opportunities.
        </p>
        <div class="mt-6">
          <a
            target="_blank"
            href="https://wa.me/message/VIGHOLT7SHWFJ1"
            class="px-6 py-3 text-lg font-medium text-white bg-primary rounded-full shadow-2xl hover:bg-primary-dark"
          >
            Get Started
          </a>
        </div>
      </div>
    </div>
  );
};

export default Hero;
